import { styled } from '@mui/material/styles';
import { Select } from '@mui/material';

export const StyledRoleSelect = styled(Select)({
  marginLeft: 16,
  height: '30px',
}); 